import React, {Component} from 'react';
import SelectBox from "./SelectBox";

class SelectBoxWithLabel extends Component {

    render() {
        return (
            <div className="filter-group">
                <div className="filter-group-header">
                    <label className="checkbox-wrapper">{this.props.label}</label>
                </div>
                <div className="filter-group-content">
                    <div className="filter-rule">
                        <div className="input-container">
                            <SelectBox
                                handleChangeSelect={this.props.handleChangeSelect}
                                selectValue={this.props.selectValue}
                                selectArray={this.props.selectArray}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SelectBoxWithLabel;
